import {  Route, Routes } from 'react-router-dom';
import React from 'react';
import './App.scss';
import Footer from './components/Footer/Footer.jsx';
import Head from './components/Headers/Head.jsx';
import Header from './components/Headers/Header.jsx';
import Contact from './Page/Contact/Contact.jsx';
import MediaPage from './Page/MediaPage/MediaPage.jsx';
import NewspaperDetail from './components/NewPaper/NewspaperDetail';
import VideoDetails from './components/Video/VideoDetails';
import NewOndetail from './components/NewPaper/NewOnDetail';
import NewsPaper from './Page/NewsPaper/Newpapers';
import DichVuVanHanh from './Page/DichVuVanHanh/DichVuVanHanh';
import MediaImage from './Page/MediaPage/MediaImage';
import SearchDetail from './components/SearchDetail';
import MediaAlbum from './Page/MediaPage/MediaAlbum';
import ScrollToTop from './components/ScrollToTop.jsx';


function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop/>
      
      <Head/>
      <main className="flex-1">
        <Routes>
          <Route exact path="/" element={<Header/>}/>
          <Route exact path="/trang-chu" element={<Header/>}/>
          <Route path="/dich-vu-van-hanh" element={<DichVuVanHanh/>}/>
          <Route path="/:categoryId" element={<NewsPaper />} />
          <Route path="/:categoryId/:Id" element={<NewspaperDetail/>}/>
          <Route path="tin-tuc/tin-hoat-dong/:newOnId" element={<NewOndetail/>}/>
          <Route path="/thu-vien-video" element={<MediaPage/>}/>
          <Route path="/thu-vien-hinh-anh" element={<MediaAlbum/>}/>
          <Route path="/thu-vien-hinh-anh/:idImage" element={<MediaImage/>}/>
          <Route path='/thu-vien-video/:newId' element={<VideoDetails/>}/>
          <Route path="/lien-he" element={<Contact/>}/>
          <Route path='/tin-tuc/:postId' element={<SearchDetail/>}/>
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
